angular.module('services.search', []).factory('searchService', ["$location", function ($location) {
  var searchFn = null;
  var redirectBase = '';

  return {
    search: function (q) {
      if (!searchFn) {
        return [];
      }

      return searchFn({q: q}).$promise;
    },
    setSearchFn: function (fn) {
      searchFn = fn;
    },
    onSelect: function (item) {
      $location.path(redirectBase + '/' + item.article_id);
    },
    setRedirectBase: function (base) {
      redirectBase = base;
    }
  };
}]);



// WEBPACK FOOTER //
// ./client/src/common/services/searchService.js